



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNEDUCATIONGETBYID= createAsyncThunk(
  "AlumniEducationGetById/AlumniEducationGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniEducationGetByIdSlice = createSlice({
  name: "AlumniEducationGetByIdSlice",
  initialState: {
    AlumniEducationGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniEducationGetById: (state) => {
        state.AlumniEducationGetById.loading = false
        state.AlumniEducationGetById.error = false
        state.AlumniEducationGetById.data = []
        state.AlumniEducationGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNEDUCATIONGETBYID.fulfilled, (state, action) => {
      state.AlumniEducationGetById = {
        ...state.AlumniEducationGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNEDUCATIONGETBYID.pending, (state, action) => {
      state.AlumniEducationGetById = {
        ...state.AlumniEducationGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNEDUCATIONGETBYID.rejected, (state, action) => {
      state.AlumniEducationGetById = {
        ...state.AlumniEducationGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniEducationGetByIdAction = {
    ALUMNEDUCATIONGETBYID,
};

export { AlumniEducationGetByIdAction };
export default AlumniEducationGetByIdSlice.reducer;
export const {setInitialStateOfAlumniEducationGetById} = AlumniEducationGetByIdSlice.actions
